import type { Scenario } from '../../sim/scenarios.js';
import type { Npc } from '../../types.js';

export default function LegacyGameBar(props: {
  scenario: Scenario;
  npcs: Npc[];
  activeCount: number;
  pendingCount: number;
  generatingCount: number;
  spawnOffline: boolean;
  llmDown: number;
  paused: boolean;
  onFit: () => void;
  onTogglePause: () => void;
  onLeave: () => void;
}): JSX.Element {
  const p = props;
  return (
    <div className="game-bar">
      <strong>CONVERSE</strong>
      <span className="pill" title={p.scenario.tagline}>
        {p.scenario.title}
      </span>
      <span className="pill">
        {p.npcs.length} minds · {p.activeCount} talking · {p.pendingCount + p.generatingCount} queued
      </span>
      {(p.spawnOffline || p.llmDown >= 3) && (
        <span className="pill" title="Dialogue/relationship calls are failing — NPCs keep wandering on procedural brains.">
          LLM unreachable — offline mode
        </span>
      )}
      <span className="spacer" />
      <button className="btn-ghost" title="Fit room to view" onClick={p.onFit}>
        ⤢ Fit
      </button>
      <button className="btn-ghost" onClick={p.onTogglePause}>
        {p.paused ? '▶ Resume' : '⏸ Pause'}
      </button>
      <button className="btn-ghost" onClick={p.onLeave}>
        ⎋ Leave
      </button>
    </div>
  );
}
